import { Button } from 'antd';
import { FC, ReactElement, memo, useCallback } from 'react';
import { ArrowRepeat } from 'react-bootstrap-icons';

import { AppModal } from '@/common/components';
import { AppModalControlProps } from '@/common/interfaces';
import { FallbackedLayout } from '@/common/layouts';

import { useGetArchivesSitesQuery } from '@/modules/Sites';

import { SitesArchivesListView } from './SitesArchivesListView';

interface Props {
  modalControls: AppModalControlProps;
  siteId: string;
}

export const SitesArchivesListContainer: FC<Props> = memo(({ siteId, modalControls }) => {
  const { isOpen } = modalControls;

  const {
    data: sitesArchivesListData,
    error: sitesArchivesListError,
    isFetching: isSitesArchivesListFetching,
    isError: isSitesArchivesListError,
    refetch: sitesArchivesListRefetch
  } = useGetArchivesSitesQuery(siteId)({
    enabled: !!siteId && isOpen
  });

  const handleRefetch = useCallback((): void => {
    sitesArchivesListRefetch();
  }, []);

  return (
    <>
      <AppModal
        title={
          <span style={{ display: 'inline-flex', alignItems: 'center' }}>
            Список імпортованих архівів сайту&nbsp;
            <Button
              disabled={ isSitesArchivesListFetching }
              type="link"
              icon={ <ArrowRepeat/> }
              size="small"
              onClick={ handleRefetch }
            />
          </span>
        }
        width={ '75%' }
        styles={{ body: { minHeight: 300 } }}
        footer={ false }
        controls={ modalControls }
      >
        <FallbackedLayout
          isLoading={ isSitesArchivesListFetching }
          error={ sitesArchivesListError }
          isError={ isSitesArchivesListError }
          data={ sitesArchivesListData }
        >
          { (sitesArchivesList): ReactElement => <SitesArchivesListView archivesList={ sitesArchivesList }/> }
        </FallbackedLayout>
      </AppModal>
    </>
  );
});
